/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Contact_Extend_Wrapup_CountInputs */

const en_forms_users_settings_contact_extend_wrapup_count = /** @type {(inputs: Forms_Users_Settings_Contact_Extend_Wrapup_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count`)
};

const de_forms_users_settings_contact_extend_wrapup_count = /** @type {(inputs: Forms_Users_Settings_Contact_Extend_Wrapup_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl`)
};

/**
* | output |
* | --- |
* | "Count" |
*
* @param {Forms_Users_Settings_Contact_Extend_Wrapup_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_contact_extend_wrapup_count = /** @type {((inputs?: Forms_Users_Settings_Contact_Extend_Wrapup_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Contact_Extend_Wrapup_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_contact_extend_wrapup_count(inputs)
	return de_forms_users_settings_contact_extend_wrapup_count(inputs)
});